import { useAllow } from '../../../components/hooks/useAllow';

export interface SubmissionReadOnlyState {
  readonly readOnly: boolean;
  readonly locked: boolean;
  readonly isAdmin: boolean;
}

/**
 * `readOnly` mirrors the backend flag. `locked` is the flag for people who
 * cannot override it: ROOT and SUBMISSIONS_MANAGE are never locked.
 */
export function useSubmissionReadOnly(submission?: {
  readonly readOnly?: boolean;
}): SubmissionReadOnlyState {
  const isAdmin = useAllow(['root:root', 'submissions:manage']);
  const readOnly = submission?.readOnly === true;

  return { readOnly, locked: readOnly && !isAdmin, isAdmin };
}
